import {CryptoSelect} from "@housebets/housebets-x-package";
import {setHideZeroBalance, setIsFiat} from "app/store/slices/setting";

import {useCryptoDropdownData} from "./hooks/useCryptoDropdown";
import {useGameData} from "app/pages/Game/hooks/useGameData";
import {useDispatch} from "react-redux";
import { useIntl } from "react-intl";

export const CryptoDropdown = () => {
    const {isFiat, hideZeroBalance, options, userCurrency, handleSelected} = useCryptoDropdownData();
    const {isUserPlayRealGame} = useGameData();
    const dispatch = useDispatch();
    const {$t} = useIntl();

    return (
        <CryptoSelect
            isFiat={isFiat}
            inGame={!!isUserPlayRealGame}
            setIsFiat={(v) => {
                dispatch(setIsFiat(v));
            }}
            isHideZeroBalance={hideZeroBalance}
            setHideZeroBalance={(e) => {
                dispatch(setHideZeroBalance(e));
            }}
            options={options}
            selectedIds={[userCurrency]}
            onSelect={handleSelected}
            text={{
                searchPlaceholder: $t({id: "SearchCurrencies"}),
                fiatSwitch: $t({id: "DisplayInFiat"}),
                zeroSwitch: $t({id: "HideZeroBalances"}),
                bet: $t({id: "Bet"}),
            }}
        />
    );
};
